// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PencilIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Pencil/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m20.268 3.732.707-.707-.707.707ZM6.5 21.035v1a1 1 0 0 0 .707-.292l-.707-.707Zm-3.5 0H2a1 1 0 0 0 1 1v-1Zm0-3.57-.707-.708a1 1 0 0 0-.293.707h1ZM17.44 4.438a1.5 1.5 0 0 1 2.12 0l1.415-1.414a3.5 3.5 0 0 0-4.95 0L17.44 4.44Zm2.12 0a1.5 1.5 0 0 1 0 2.122l1.415 1.414a3.5 3.5 0 0 0 0-4.95L19.56 4.44Zm0 2.122L5.794 20.328l1.414 1.415L20.975 7.975 19.56 6.56ZM6.5 20.035H3v2h3.5v-2Zm9.525-17.01L2.293 16.757l1.414 1.415L17.44 4.439l-1.414-1.414ZM2 17.465v3.57h2v-3.57H2ZM14.525 5.938l3.536 3.536 1.414-1.414-3.536-3.536-1.414 1.414Z"
}));
export default PencilIcon;